<app-status-bar></app-status-bar>
<div class="wrapper w-100 pass-sale-wrapper" [class.panel-collapsed]="panelCollapsed">

    <!-- SUCCESS OVERLAY: non-dismissible, only navigation options -->
    <div class="pass-success-overlay" *ngIf="passAdded">
        <div class="pass-success-card">
            <div class="success-icon">
                <fa-icon [icon]="faCircleCheck"></fa-icon>
            </div>
            <h2 class="success-title">¡Abono añadido al carrito!</h2>
            <p class="success-pass-name" *ngIf="pass">{{ pass.name }}</p>
            <div class="success-actions">
                <button class="btn-success-primary" routerLink="/home">
                    <fa-icon [icon]="faPlus"></fa-icon>
                    <span>Más entradas</span>
                </button>
                <button class="btn-success-secondary" routerLink="/passes">
                    <fa-icon [icon]="faTicket"></fa-icon>
                    <span>Añadir otro abono</span>
                </button>
            </div>
        </div>
    </div>

    <!-- SELECTION FLOW -->
    <div class="pass-layout">

        <!-- Left sidebar: pass event list with progress -->
        <div class="pass-sidebar">
            <div class="pass-sidebar-scroll" [class.picker-open]="openDatePicker">
                <div class="go-back" (click)="goBack()">
                    <i class="fa-sharp fa-thin fa-arrow-left"></i>
                    <span>Abonos</span>
                </div>

                <div *ngIf="loading" class="loading-spinner">
                    <mat-progress-spinner color="accent" mode="indeterminate" diameter="30">
                    </mat-progress-spinner>
                </div>

                <ng-container *ngIf="!loading && pass">
                    <div class="pass-sidebar-header">
                        <div class="pass-sidebar-name">{{ pass.name }}</div>
                    </div>

                    <!-- Abono de butaca única: los eventos son informativos -->
                    <ng-container *ngIf="isSingleSeat()">
                        <div class="pass-progress-bar">
                            <span>Butaca única · {{ passSeats.length }}/{{ passQuantity }} butaca{{ passQuantity > 1 ? 's' : '' }}</span>
                        </div>
                        <p class="pass-single-seat-hint">
                            La butaca que elijas en el mapa será la misma en los {{ getPassItems().length }} eventos del abono.
                            <ng-container *ngIf="!isFixedPrices()">Se cobra la entrada general de cada uno.</ng-container>
                            <ng-container *ngIf="isFixedPrices()">Se cobra el precio del abono según la zona de la butaca.</ng-container>
                        </p>
                        <div class="pass-event-list">
                            <div class="pass-event-item pass-event-item--static" *ngFor="let item of getSingleSeatItems()">
                                <fa-icon [icon]="faCalendar" class="event-check"></fa-icon>
                                <div class="event-info">
                                    <span class="event-name">{{ getEvent(item).title }}</span>
                                    <span class="event-date" *ngIf="item.session?.start_date || getEvent(item).start_date">
                                        {{ (item.session?.start_date || getEvent(item).start_date) | date: 'dd MMM yyyy · HH:mm':'+0000' }}h
                                    </span>
                                </div>
                            </div>
                        </div>
                    </ng-container>

                    <ng-container *ngIf="!isSingleSeat()">
                    <!-- Progress info -->
                    <div class="pass-progress-bar">
                        <span>{{ getCompletedCount() }}/{{ getMinEvents() }} eventos</span>
                        <div class="filter-toggle" (click)="toggleFilters()"
                            [class.active]="filtersOpen || hasActiveFilters()">
                            <fa-icon [icon]="faSliders"></fa-icon>
                        </div>
                    </div>

                    <!-- Collapsible filters -->
                    <div class="pass-filters" *ngIf="filtersOpen">
                        <div class="pass-filter-search">
                            <i class="fal fa-search"></i>
                            <input type="text" [value]="searchText"
                                (input)="onSearchChange($any($event.target).value)"
                                placeholder="Buscar evento">
                        </div>

                        <div class="pass-filter-date" #fechaDropdown>
                            <div class="date-filter-trigger" (click)="openDatePicker=!openDatePicker"
                                [class.active]="fromDate">
                                <i class="fal fa-calendar"></i>
                                <span class="date-label" *ngIf="!stringDate">Fecha</span>
                                <span class="date-label" *ngIf="stringDate">{{ stringDate }}</span>
                                <i class="fal fa-angle-down arrow-icon"></i>
                            </div>
                            <div class="calendar-dropdown" *ngIf="openDatePicker">
                                <ngb-datepicker class="custom-datepicker-event" #dp [displayMonths]="1"
                                    [dayTemplate]="t" outsideDays="visible" (dateSelect)="changeDate($event)"
                                    [minDate]="minDate" (navigate)="dateNavigate($event)">
                                    <ng-template #t let-date let-focused="focused">
                                        <span class="custom-day"
                                            [class.focused]="fromDate != null && hoveredDate != null"
                                            [class.first-select]="isFromDate(date)"
                                            [class.last-select]="isToDate(date)"
                                            [class.faded]="isHovered(date) || isInside(date)"
                                            [class.border-monday]="isMonday(date)"
                                            [class.border-sunday]="isSunday(date)"
                                            [class.range]="isRange(date)"
                                            [class.day-disabled]="isDisabled(date)"
                                            (mouseenter)="hoveredDate = date"
                                            (mouseleave)="hoveredDate = null">
                                            <span class="inside-day"
                                                [class.weekend]="isWeekend(date)">{{ date.day }}</span>
                                        </span>
                                    </ng-template>
                                </ngb-datepicker>
                            </div>
                        </div>

                        <div class="btn-clear-filter" (click)="clearFilters()" *ngIf="hasActiveFilters()">
                            <fa-icon [icon]="faTimes"></fa-icon>
                            <span>Limpiar</span>
                        </div>
                    </div>

                    <!-- Event list -->
                    <div class="pass-event-list" *ngIf="getFilteredPassItems().length">
                        <div class="pass-event-item"
                            *ngFor="let item of getFilteredPassItems()"
                            [class.current]="isCurrentEvent(getEvent(item).id)"
                            [class.completed]="isEventCompleted(getEvent(item).id)"
                            (click)="selectEvent(item)">
                            <fa-icon [icon]="faCheck" class="event-check"
                                [class.done]="isEventCompleted(getEvent(item).id)">
                            </fa-icon>
                            <div class="event-info">
                                <span class="event-name">{{ getEvent(item).title }}</span>
                                <span class="event-date" *ngIf="getEvent(item).start_date">
                                    {{ getEvent(item).start_date | date: 'dd MMM yyyy · HH:mm':'+0000' }}h
                                </span>
                                <span class="event-type" *ngIf="hasMap(item)">
                                    <fa-icon [icon]="faChair"></fa-icon> Con mapa
                                </span>
                            </div>
                        </div>
                    </div>

                    <!-- Add pass to cart button -->
                    <button class="btn-add-pass"
                        *ngIf="allEventsCompleted()"
                        [disabled]="submitting"
                        (click)="addPassToCart()">
                        <fa-icon [icon]="faTicket"></fa-icon>
                        <span *ngIf="!submitting">Añadir abono</span>
                        <span *ngIf="submitting">Añadiendo...</span>
                    </button>
                    </ng-container>
                </ng-container>
            </div>
        </div>

        <!-- Center: seat-map in pass mode -->
        <div class="pass-center">
            <!-- Se espera al abono para saber qué mapa montar: el de la sesión o el del abono entero -->
            <ng-container *ngIf="currentEventId && pass">
                <app-seat-map *ngIf="!isSingleSeat()"
                    [passMode]="true"
                    [fixedPricePass]="isFixedPrices() ? pass : null"
                    [passMaxSeats]="1"
                    [passSelectedCount]="eventSelections.has(currentEventId) ? 1 : 0"
                    [passPreselectedSeatIds]="getPreselectedSeatIds(currentEventId)"
                    [allowedSessionIds]="currentAllowedSessionIds"
                    (passSelection)="onEventSelection($event)">
                </app-seat-map>
                <app-seat-map *ngIf="isSingleSeat()"
                    [passMode]="true"
                    [singleSeatPass]="pass"
                    [passMaxSeats]="passQuantity"
                    [passSelectedCount]="passSeats.length"
                    [passPreselectedSeatIds]="passSeatIds"
                    [allowedSessionIds]="currentAllowedSessionIds"
                    (passSelection)="onPassSeatSelected($event)">
                </app-seat-map>
            </ng-container>
        </div>

        <!-- Right panel: pass selections preview -->
        <div class="cart-panel" style="margin-top: 80px;">
            <button class="cart-toggle-btn" (click)="togglePanel()" [title]="panelCollapsed ? 'Mostrar resumen' : 'Ocultar resumen'">
                <span class="cart-icon-wrap">
                    <fa-icon [icon]="faTicket"></fa-icon>
                    <span class="cart-toggle-badge" *ngIf="(isSingleSeat() ? passSeats.length : getCompletedCount()) > 0">{{ isSingleSeat() ? passSeats.length : getCompletedCount() }}</span>
                </span>
                <i class="cart-toggle-chevron fa-light" [class.fa-chevron-right]="!panelCollapsed" [class.fa-chevron-left]="panelCollapsed"></i>
            </button>
            <div class="cart-panel-inner" [class.panel-inner-collapsed]="panelCollapsed">
            <!-- Abono de butaca única: una fila por butaca (cada una es un abono) -->
            <div class="pass-selections-panel" *ngIf="isSingleSeat()">
                <div class="pass-panel-header">
                    <div>
                        <p class="pass-panel-title">Abono · butaca única</p>
                        <p class="pass-panel-subtitle" *ngIf="pass">{{ pass.name }}</p>
                    </div>
                    <button class="btn-clear-all" *ngIf="passSeats.length > 0" (click)="clearPassSeats()" title="Vaciar selección">
                        <fa-icon [icon]="faTrash"></fa-icon>
                    </button>
                </div>

                <div class="pass-selections-scroll">
                    <div *ngIf="passSeats.length === 0" class="pass-selections-empty">
                        <fa-icon [icon]="faChair" class="empty-pass-icon"></fa-icon>
                        <p class="empty-pass-title">Sin butacas</p>
                        <p class="empty-pass-subtitle">Elige {{ passQuantity > 1 ? passQuantity + ' butacas' : 'la butaca' }} en el mapa</p>
                    </div>

                    <div *ngIf="passSeats.length > 0" class="pass-selections-list">
                        <div class="pass-selection-item" *ngFor="let seat of passSeats; let i = index">
                            <div class="sel-img">
                                <div class="sel-img-placeholder">{{ i + 1 }}</div>
                            </div>
                            <div class="sel-info">
                                <div class="sel-event-title">{{ seat.level || seat.section }}</div>
                                <div class="sel-seat">
                                    <div class="sel-seat-detail">
                                        <span *ngIf="seat.row">Fila: {{ seat.row }}</span>
                                        <span class="sel-seat-sep" *ngIf="seat.row && seat.seat">·</span>
                                        <span *ngIf="seat.seat">Butaca: {{ seat.seat }}</span>
                                    </div>
                                </div>
                                <div class="sel-ticket-row">
                                    <span class="sel-ticket-name">
                                        {{ getPassItems().length }} eventos
                                        <ng-container *ngIf="getPassSeatTotal(seat.id) !== null"> · {{ getPassSeatTotal(seat.id) | number:'1.2-2' }} €</ng-container>
                                    </span>
                                </div>
                            </div>
                            <div class="sel-remove" (click)="removePassSeat(seat.id)">
                                <fa-icon [icon]="faTrash"></fa-icon>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="pass-selections-footer">
                    <div class="pass-selections-count">
                        {{ passSeats.length }}/{{ passQuantity }} butaca{{ passQuantity > 1 ? 's' : '' }}
                        <ng-container *ngIf="passQuote"> · {{ passQuote.total | number:'1.2-2' }} €</ng-container>
                    </div>
                    <button class="btn-add-pass-bottom"
                        [disabled]="!allPassSeatsSelected() || submitting"
                        (click)="addSingleSeatPassToCart()">
                        <span class="btn-pass-label">{{ submitting ? 'AÑADIENDO...' : (passQuantity > 1 ? 'AÑADIR ABONOS' : 'AÑADIR ABONO') }}</span>
                        <span class="btn-pass-count" *ngIf="passQuote">{{ passQuote.total | number:'1.2-2' }} €</span>
                    </button>
                </div>
            </div>

            <div class="pass-selections-panel" *ngIf="!isSingleSeat()">

                <!-- Header fijo -->
                <div class="pass-panel-header">
                    <div>
                        <p class="pass-panel-title">Abono</p>
                        <p class="pass-panel-subtitle" *ngIf="pass">{{ pass.name }}</p>
                    </div>
                    <button class="btn-clear-all" *ngIf="getSelectionsList().length > 0" (click)="clearAllSelections()" title="Vaciar selección">
                        <fa-icon [icon]="faTrash"></fa-icon>
                    </button>
                </div>

                <!-- Scrollable content -->
                <div class="pass-selections-scroll">

                    <!-- Empty state -->
                    <div *ngIf="getSelectionsList().length === 0" class="pass-selections-empty">
                        <fa-icon [icon]="faTicket" class="empty-pass-icon"></fa-icon>
                        <p class="empty-pass-title">Sin selecciones</p>
                        <p class="empty-pass-subtitle">Selecciona entradas para cada evento del abono</p>
                    </div>

                    <!-- Selection list -->
                    <div *ngIf="getSelectionsList().length > 0" class="pass-selections-list">
                        <div class="pass-selection-item" *ngFor="let sel of getSelectionsList(); trackBy: trackSelectionByEventId">
                            <div class="sel-img">
                                <img *ngIf="sel.detail.eventImage" [src]="urlImages + sel.detail.eventImage" />
                                <div class="sel-img-placeholder" *ngIf="!sel.detail.eventImage">
                                    <fa-icon [icon]="faCalendar"></fa-icon>
                                </div>
                            </div>
                            <div class="sel-info">
                                <div class="sel-event-title">{{ sel.detail.eventTitle }}</div>
                                <div class="sel-session" *ngIf="sel.detail.sessionDate">
                                    <fa-icon [icon]="faCalendar"></fa-icon>
                                    <span>{{ sel.detail.sessionDate | date: 'dd MMM yyyy · HH:mm':'+0000' }}h</span>
                                </div>
                                <div class="sel-ticket-row">
                                    <span class="sel-ticket-name">
                                        {{ sel.detail.ticketName }}
                                        <ng-container *ngIf="isFixedPrices() && sel.detail.ticketPrice != null"> · {{ getSelectionTotal(sel.eventId) | number:'1.2-2' }} €</ng-container>
                                    </span>
                                </div>
                                <div class="sel-seat" *ngIf="sel.detail.seatRow || sel.detail.seatSeat || sel.detail.seatSection">
                                    <div class="sel-seat-section">
                                        <fa-icon [icon]="faChair"></fa-icon>
                                        <span *ngIf="sel.detail.seatSection">{{ sel.detail.seatSection }}</span>
                                    </div>
                                    <div class="sel-seat-detail" *ngIf="sel.detail.seatRow || sel.detail.seatSeat">
                                        <span *ngIf="sel.detail.seatRow">Fila: {{ sel.detail.seatRow }}</span>
                                        <span class="sel-seat-sep" *ngIf="sel.detail.seatRow && sel.detail.seatSeat">·</span>
                                        <span *ngIf="sel.detail.seatSeat">Butaca: {{ sel.detail.seatSeat }}</span>
                                    </div>
                                </div>
                            </div>
                            <div class="sel-remove" (click)="removeSelection(sel.eventId)">
                                <fa-icon [icon]="faTrash"></fa-icon>
                            </div>
                        </div>
                    </div>

                </div>

                <!-- Footer fijo -->
                <div class="pass-selections-footer">
                    <div class="pass-selections-count">
                        {{ getCompletedCount() }}/{{ getMinEvents() }} eventos seleccionados
                        <ng-container *ngIf="isFixedPrices() && getCompletedCount() > 0"> · {{ getSelectionsTotal() | number:'1.2-2' }} €</ng-container>
                    </div>
                    <button class="btn-add-pass-bottom"
                        [disabled]="!allEventsCompleted() || submitting"
                        (click)="addPassToCart()">
                        <span class="btn-pass-label">{{ submitting ? 'AÑADIENDO...' : 'AÑADIR ABONO' }}</span>
                        <span class="btn-pass-count" *ngIf="getCompletedCount() > 0">{{ getCompletedCount() }} evento{{ getCompletedCount() > 1 ? 's' : '' }}</span>
                    </button>
                </div>

            </div>
            </div>
        </div>
    </div>
</div>

